const white = '#FFFFFF';
const black = '#000000';
export { black, white };

//# sourceMappingURL=common.js.map